import { render, staticRenderFns } from "./ParallelogramA.vue?vue&type=template&id=e6f9fd48&scoped=true"
import script from "./ParallelogramA.vue?vue&type=script&lang=js"
export * from "./ParallelogramA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f9fd48",
  null
  
)

export default component.exports